import CreateEditPriceForm from './CreateEditPriceForm';

export default CreateEditPriceForm;
